import messagesListTemplate from '../../../../modules/Messages/messages_list.html';
import messagesMessageTemplate from '../../../../modules/Messages/messages_message.html';
import messagesRecipientsTemplate from '../../../../modules/Messages/messages_recipients.html';
import channellistContainerTemplate from '../../../../modules/VerticalChannel/templates/channellist_container.html';
import channellistTitleTemplate from '../../../../modules/VerticalChannel/templates/channellist_title.html';
import verticalListTemplate from '../../../../modules/VerticalChannel/templates/vertical_list.html';
import authQrTemplate from '../../../../templates/auth-qr.html';
import castPageTemplate from '../../../../templates/cast_page.html';
import defaultTemplate from '../../../../templates/default.html';
import featuresLegendTemplate from '../../../../templates/features_legend.html';
import featuresServicesWakeupTemplate from '../../../../templates/features_services_wakeup.html';
import featuresServicesWakeupLegendTemplate from '../../../../templates/features_services_wakeup_legend.html';
import featuresSubstrateTemplate from '../../../../templates/features_substrate.html';
import feedbackTemplate from '../../../../templates/feedback.html';
import fullscreenOverlayTemplate from '../../../../templates/fullscreen_overlay.html';
import fullscreenVideoTemplate from '../../../../templates/fullscreen_video.html';
import galleryTemplate from '../../../../templates/gallery.html';
import guideTemplate from '../../../../templates/guide.html';
import informationTemplate from '../../../../templates/information.html';
import innerMenuItemTemplate from '../../../../templates/inner_menu_item.html';
import languageTemplate from '../../../../templates/language.html';
import listItemsTemplate from '../../../../templates/list_items/list_items.html';
import listItemsToppingsTemplate from '../../../../templates/list_items_toppings.html';
import menuWeatherS1x1Template from '../../../../templates/menu_weather_s1x1.html';
import menuWeatherS2x1Template from '../../../../templates/menu_weather_s2x1.html';
import menuWeatherS2x2Template from '../../../../templates/menu_weather_s2x2.html';
import menuWeatherScandicTemplate from '../../../../templates/menu_weather_scandic.html';
import mosaicTemplate from '../../../../templates/mosaic.html';
import moviePageTemplate from '../../../../templates/movie_page.html';
import parentalLockTemplate from '../../../../templates/parental_lock.html';
import popupListTemplate from '../../../../templates/popup_list.html';
import radioActionTemplate from '../../../../templates/radio_action.html';
import radioPreviewTemplate from '../../../../templates/radio_preview.html';
import rcuTemplate from '../../../../templates/rcu.html';
import roomControlDemoTemplate from '../../../../templates/room_control_demo.html';
import samplePageTemplate from '../../../../templates/sample_page.html';
import servicePageForDataTemplate from '../../../../templates/service_page_for_data.html';
import settingsTemplate from '../../../../templates/settings.html';
import sourcesPageTemplate from '../../../../templates/sources_page.html';
import sourcesPageOldTemplate from '../../../../templates/sources_page_old.html';
import tableTemplate from '../../../../templates/table/table.html';
import tvChannelChoosingListTemplate from '../../../../templates/tv_channel_choosing_list.html';
import tvChannelContainerTemplate from '../../../../templates/tv_channel_container.html';
import tvChannelEpgTemplate from '../../../../templates/tv_channel_epg.html';
import tvChannelInformationTemplate from '../../../../templates/tv_channel_information.html';
import tvChannelListTemplate from '../../../../templates/tv_channel_list.html';
import tvChannelListLanguageTemplate from '../../../../templates/tv_channel_list_language.html';
import tvChannelListRefreshTemplate from '../../../../templates/tv_channel_list_refresh.html';
import tvChannelPreviewTemplate from '../../../../templates/tv_channel_preview.html';
import tvControlDemoTemplate from '../../../../templates/tv_control_demo.html';
import tvStationChoosingListTemplate from '../../../../templates/tv_station_choosing_list.html';
import tvStationListTemplate from '../../../../templates/tv_station_list.html';
import tvStationListRefreshTemplate from '../../../../templates/tv_station_list_refresh.html';
import wakeupNewTemplate from '../../../../templates/wakeup_new.html';
import weatherForecastTemplate from '../../../../templates/weather_forecast.html';
import weatherSelectLocationTemplate from '../../../../templates/weather_select_location.html';
import welcomeScreenTemplate from '../../../../templates/welcome_screen.html';
import tvChannelListItemTemplate from '../../../../modules/VirtualScroll/templates/tv_channellist-item.html';

/**
 * List of templates to load on application startup
 * TODO: refactor to components with static imports
 */
export const defaultTemplates: Record<string, string> = {
  'messages_list': messagesListTemplate,
  'messages_message': messagesMessageTemplate,
  'messages_recipients': messagesRecipientsTemplate,
  'channellist_container': channellistContainerTemplate,
  'channellist_title': channellistTitleTemplate,
  'vertical_list': verticalListTemplate,
  'auth-qr': authQrTemplate,
  'cast_page': castPageTemplate,
  'default': defaultTemplate,
  'features_legend': featuresLegendTemplate,
  'features_services_wakeup': featuresServicesWakeupTemplate,
  'features_services_wakeup_legend': featuresServicesWakeupLegendTemplate,
  'features_substrate': featuresSubstrateTemplate,
  'feedback': feedbackTemplate,
  'fullscreen_overlay': fullscreenOverlayTemplate,
  'fullscreen_video': fullscreenVideoTemplate,
  'gallery': galleryTemplate,
  'guide': guideTemplate,
  'information': informationTemplate,
  'inner_menu_item': innerMenuItemTemplate,
  'language': languageTemplate,
  'list_items': listItemsTemplate,
  'list_items_toppings': listItemsToppingsTemplate,
  'menu_weather_s1x1': menuWeatherS1x1Template,
  'menu_weather_s2x1': menuWeatherS2x1Template,
  'menu_weather_s2x2': menuWeatherS2x2Template,
  'menu_weather_scandic': menuWeatherScandicTemplate,
  'mosaic': mosaicTemplate,
  'movie_page': moviePageTemplate,
  'parental_lock': parentalLockTemplate,
  'popup_list': popupListTemplate,
  'radio_action': radioActionTemplate,
  'radio_preview': radioPreviewTemplate,
  'rcu': rcuTemplate,
  'room_control_demo': roomControlDemoTemplate,
  'sample_page': samplePageTemplate,
  'service_page_for_data': servicePageForDataTemplate,
  'settings': settingsTemplate,
  'sources_page': sourcesPageTemplate,
  'sources_page_old': sourcesPageOldTemplate,
  'table': tableTemplate,
  'tv_channel_choosing_list': tvChannelChoosingListTemplate,
  'tv_channel_container': tvChannelContainerTemplate,
  'tv_channel_epg': tvChannelEpgTemplate,
  'tv_channel_information': tvChannelInformationTemplate,
  'tv_channel_list': tvChannelListTemplate,
  'tv_channel_list_language': tvChannelListLanguageTemplate,
  'tv_channel_list_refresh': tvChannelListRefreshTemplate,
  'tv_channel_preview': tvChannelPreviewTemplate,
  'tv_control_demo': tvControlDemoTemplate,
  'tv_station_choosing_list': tvStationChoosingListTemplate,
  'tv_station_list': tvStationListTemplate,
  'tv_station_list_refresh': tvStationListRefreshTemplate,
  'wakeup_new': wakeupNewTemplate,
  'weather_forecast': weatherForecastTemplate,
  'weather_select_location': weatherSelectLocationTemplate,
  'welcome_screen': welcomeScreenTemplate,
  'tv_channellist-item': tvChannelListItemTemplate,
};
